import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { iniciarPixel } from './lib/pixel'
import { iniciarSincronizacionAutomatica } from './lib/colaOffline'

// Si no hay identificador de píxel configurado, esto no hace nada: no
// carga ningún script de Meta ni manda un solo dato.
iniciarPixel()

// Sube lo que quedó anotado sin señal. Se dispara al arrancar, al
// volver la conexión y al traer la app al frente.
iniciarSincronizacionAutomatica()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
